import config from '../config/app'
import axios from 'axios'

const PATH = 'invite'
const VERSION = '/v2/'
export default {
  getInvites (params, additional) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  newGetInvitedByUserId (userId, additionalFields, params) {
    params = typeof params === 'object' && params !== null ? params : {}
    params.user_id = userId
    return this.getInvites(params, additionalFields)
  },
  getReferralCount (companyId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/v2/invite/referral-count?company_id=' + companyId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  newSendInvites (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + PATH, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  // ==============================================================
  get (params, additional) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/' + PATH + '?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByInvite (invite, additionalFields) {
    return new Promise((resolve, reject) => {
      this.get({key: invite}, additionalFields).then((response) => {
        resolve(response[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getInvitedByUserId (userId, additionalFields, params) {
    params = typeof params === 'object' && params !== null ? params : {}
    params.user_id = userId
    return this.get(params, additionalFields)
  },
  sendInvite (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/' + PATH, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteInvitation (emailId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + PATH + '/delete-invitation', {email: emailId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  importCsvData (formData, companyId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + PATH + '/import-csv', formData, {
        headers: { 'content-type': 'multipart/form-data' }}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/invite.js